import React from "react";
import Header from "./dashboard/Header";
import Footer from "./footer/Footer";

const SuperAdminLayout = ({ children, title, count, toolbarLeft, toolbarRight }) => {
  return (
    <div className="crm-layout">
      <Header />
      <div className="crm-main-content">
        <div className="crm-page-body">
          {title ? (
            <div className="crm-card">
              <div className="crm-card-header">
                <h3 className="crm-card-title">{title}</h3>
                {count !== undefined && count !== null && (
                  <div className="crm-badge-counter">Items in list: {count}</div>
                )}
              </div>
              {(toolbarLeft || toolbarRight) && (
                <div className="crm-toolbar">
                  <div className="crm-toolbar-left">{toolbarLeft}</div>
                  <div className="crm-toolbar-right">{toolbarRight}</div>
                </div>
              )}
              {children}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SuperAdminLayout;
